import React from 'react';
import styled from 'styled-components';

import { Pagination } from './Pagination';

type Props = {
  hasNextPage: boolean | undefined;
  fetchNextPage: () => void;
  isLoading: boolean;
  pageSize: number;
  children: React.ReactNode;
};

const Root = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  gap: 16px;
  min-width: 182px;
`;

export const ImageGridLoader = ({ hasNextPage, fetchNextPage, isLoading, pageSize, children }: Props) => {
  return (
    <Root>
      {children}
      {hasNextPage !== false && (
        <Pagination fetchNextPage={fetchNextPage} skeletonCount={pageSize / 2} isLoading={isLoading} />
      )}
    </Root>
  );
};
